var map = {
	"./de-DE/app-annotation": 42586,
	"./en-US/app-annotation": 12867,
	"./es-ES/app-annotation": 49372,
	"./fa-IR/app-annotation": 17172,
	"./fr-FR/app-annotation": 79552,
	"./hi-IN/app-annotation": 21850,
	"./it-IT/app-annotation": 53970,
	"./ja-JP/app-annotation": 65843,
	"./ko-KR/app-annotation": 65109,
	"./pl-PL/app-annotation": 81564,
	"./pt-BR/app-annotation": 87732,
	"./ro-RO/app-annotation": 12658,
	"./ru-RU/app-annotation": 24190,
	"./sl-SI/app-annotation": 90955,
	"./th-TH/app-annotation": 84804,
	"./tr-TR/app-annotation": 17796,
	"./uk-UA/app-annotation": 29922,
	"./vi-VN/app-annotation": 69265,
	"./zh-Hans/app-annotation": 31902,
	"./zh-Hant/app-annotation": 44337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9902;